import * as R from 'ramda';
import adapter from 'dataModule/adapter';
import { httpGet, httpPost, httpPut, httpDelete, httpPatch } from 'apiModule/rest';
import { getQueriesString, getIdsObject } from 'utilsModule';
import api from 'apiModule/rest';

// fetch patient today's tasks
const fetchList = body => api.task.fetchList('tasks', body);

const retrieveProgramTasks = async ({ content }) =>
  R.pipe(adapter.task.retrieveProgramTasks.fe2be, httpPost('tasks'), (response) =>
    response.then(adapter.task.retrieveProgramTasks.be2fe),
  )(content);

const DM = {
  retrieveProgramTasks
};

const ajax = async ({ method, input }) => ({ [method]: await DM[method](input) });

export default { fetchList, ...DM, ajax };